import React from 'react';

import PropTypes from 'prop-types';
import { Container, Inner } from './styles';

import parse from 'html-react-parser';

export default function Section04TimelineItem({
  order,
  title,
  text,
  image,
  openModal,
}) {
  return (
    <Container className={order % 2 === 0 ? 'right' : 'left'}>
      <Inner data-order={order} className={image == null ? 'no-image' : ''}>
        <header>
          <h2>{title}</h2>
          <p>{parse(text)}</p>
        </header>
        {image == null ? (
          ''
        ) : (
          <img src={image} alt={title} onClick={() => openModal(image)} />
        )}
      </Inner>
    </Container>
  );
}

Section04TimelineItem.propTypes = {
  order: PropTypes.number,
  title: PropTypes.string,
  text: PropTypes.string,
  image: PropTypes.string,
  openModal: PropTypes.func,
};
